import { RootState } from 'src/store';

import { IMerchantAccount } from '../accountsPayment/types';

export const selectAccountsPayoutLoading = (state: RootState): boolean => state.accountsPayout.isLoading;
export const selectAccountsPayoutLoaded = (state: RootState): boolean => state.accountsPayout.isLoaded;
export const selectAccountPayoutDetails = (state: RootState): IMerchantAccount | null => state.accountsPayout.details;
